import React from "react";
import { Routes, Route, Link, Outlet } from "react-router-dom";
import { Container, Row, Col, Nav } from "react-bootstrap";
import Dashboard from "./pages/Dashboard";
import Licenses from "./pages/Licenses";
import CreateLicense from "./pages/CreateLicense";
import Activations from "./pages/Activations";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import { FaHome, FaKey, FaPlus, FaUsers, FaCog } from "react-icons/fa";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import Header from "./components/Header";
import logo from "./assets/images/detection-x_light_wo_subtitle.svg";

// Layout component for the admin dashboard
const AdminLayout = () => (
  <Container fluid>
    <Row>
      {/* Sidebar */}
      <Col md={2} className="sidebar p-0 bg-dark text-white">
        <div className="p-4">
          <div className="mb-4">
            <img
              src={logo}
              alt="Detection-X"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </div>
          <h4 className="mb-4">Admin Panel</h4>
          <Nav className="flex-column">
            <Nav.Item>
              <Link to="/" className="nav-link text-white">
                <FaHome className="me-2" /> Dashboard
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link to="/licenses" className="nav-link text-white">
                <FaKey className="me-2" /> Licenses
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link to="/create-license" className="nav-link text-white">
                <FaPlus className="me-2" /> Create License
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link to="/activations" className="nav-link text-white">
                <FaUsers className="me-2" /> Activations
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link to="/settings" className="nav-link text-white">
                <FaCog className="me-2" /> Settings
              </Link>
            </Nav.Item>
          </Nav>
        </div>
      </Col>

      {/* Main content */}
      <Col md={10} className="main-content p-4">
        <Outlet />
      </Col>
    </Row>
  </Container>
);

function App() {
  return (
    <AuthProvider>
      <Header />
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Protected Routes */}
        <Route element={<PrivateRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="licenses" element={<Licenses />} />
            <Route path="create-license" element={<CreateLicense />} />
            <Route path="activations" element={<Activations />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
